import React from "react";
import { Container, Row } from "reactstrap";
import LeftSideContent from "./LeftSideContent/";
import RightSideContent from "./RightSideContent";
import Section from "./Section";
import { useParams } from "react-router-dom";
import MetaTags from "../../../../helpers/Common/MetaTags";
import { getMetaConfig } from "../../../../helpers/Common/metaConfig";
import { useState } from "react";
import { useEffect } from "react";
import { getSingleCompany } from "../../../../api/companies";
import SmallLoader from "../../../../helpers/Common/SmallLoader";
import { scrollWindow } from "../../../../helpers/common";

const CompanyDetails = () => {
  const { companyId } = useParams();
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSingleCompany(companyId)
      .then((res) => {
        if (res.status === 200 && res?.data) {
          setDetails(res?.data);
        }
      })
      .catch((err) => {
        console.log("err::", err);
      })
      .finally(() => {
        setLoading(false);
      });

    scrollWindow();
  }, [companyId]);

  const companyDetailsMeta = getMetaConfig('companyDetails', {
    title: details?.name || 'Company Profile',
    description: details?.description ? 
      `${details.name} - ${details.description.substring(0, 150)}...` : 
      'Learn about companies, their culture, values, and job opportunities. Find the perfect employer that matches your career goals.',
    keywords: `${details?.name || 'company'}, ${details?.industry || 'employer'}, company culture, job opportunities, career`,
    ogTitle: details?.name || 'Company Profile - JobSeekers Pages',
    ogDescription: details?.description ? 
      `${details.name} - ${details.description.substring(0, 150)}...` : 
      'Discover company culture, values, and job opportunities from potential employers.',
  });

  return (
    <React.Fragment>
      <MetaTags {...companyDetailsMeta} />
      <Section />
      <section className="section">
        {loading ? (
          <SmallLoader />
        ) : (
          <Container>
            <Row>
              <LeftSideContent details={details} />
              <RightSideContent details={details} />
            </Row>
          </Container>
        )}
      </section>
    </React.Fragment>
  );
};

export default CompanyDetails;
